module.exports = __webpack_public_path__ + "img/construction.6ad770c8.png";